import { Injectable } from '@angular/core';
import { FileHelper } from './helpers/file-helper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CurrentService } from './current.service';
import { Tools } from './helpers/tools';
import { CONFIG_CONTEXT } from '../enum/config-context.enum';
import { environment } from 'src/environments/environment';
import { logError } from './helpers/sentry.helper';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProcessQuoteService {
  constructor(
    private http: HttpClient,
    private current: CurrentService
  ) {}

  generateLegacyCommerceCSV(
    productList: any,
    projectUuid: string,
    projectName: string,
    projectContext: string,
    customerId: string,
    customerName: string,
    vendorId: string,
    legacyStoreId: string
  ): string {
    let _rows: any = [];

    let _rightNow = new Date();
    let _rightNowStr = _rightNow.toISOString().slice(0, 19).replace(/-/g, '/').replace('T', ':');

    let _preffix = '3D';
    switch (projectContext) {
      case CONFIG_CONTEXT.KITCHEN:
        _preffix += 'C';
        break;
      case CONFIG_CONTEXT.STORAGE:
        _preffix += 'R';
        break;

      default:
        break;
    }

    _rows.push([_preffix, 1, legacyStoreId + '/' + vendorId]);
    _rows.push([_preffix, 3, _rightNowStr]);
    _rows.push([_preffix, 5, customerName.length > 30 ? customerName.substr(0, 30) : customerName]);
    _rows.push([_preffix, 6, projectUuid + '/' + projectName]);
    _rows.push([_preffix, 7, customerId]);

    for (let i = 0; i < productList.length; i++) {
      const _p = productList[i];
      if (_p.quantity <= 0) continue;
      _rows.push([_p.reference, _p.quantity]);
    }

    return FileHelper.arrayToCsv(_rows);
  }

 /**
  * Échappe les caractères spéciaux pour les rendre compatibles avec le format XML.
  */
  private escapeXml(unsafeString: string): string {
    if (!unsafeString) return unsafeString;

    return unsafeString
        .replaceAll('&', '&amp;') // Doit impérativement être la première modification
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
  }

  generateDotComPlusXML(
    productList: any,
    projectName: string,
    projectContext: string,
    customerId: string,
    vendorId: string,
    storeId: string
  ): string {
    const _customerId = `${customerId.startsWith('SQ_') ? '' : 'SQ_'}${customerId}`;

    let _rightNow = new Date();

    let _altDocIdPrefix = '';
    let _quoteTypeLetter = '';
    let _senderComponentId = '';

    switch (projectContext) {
      case CONFIG_CONTEXT.KITCHEN:
      case CONFIG_CONTEXT.STORAGE:
      case CONFIG_CONTEXT.BATHROOM:
      case CONFIG_CONTEXT.POSE:
        _senderComponentId = 'HOMEBYME';
        _altDocIdPrefix = 'HBM-';
        _quoteTypeLetter = 'K';
        break;
      default:
        break;
    }

    let _creationDateStr = _rightNow.toISOString().slice(0, 19);
    let _timestampStr = _creationDateStr.replace(/-/g, '').replace(/\:/g, '').replace('T', '');
    let _uid = _customerId.substr(_customerId.length - 8, 8) + _timestampStr;
    let _vendorIdFordocId = vendorId.toUpperCase().replace(/[^A-Z0-9]/g, '');
    let _docId = _vendorIdFordocId.substr(0, Math.min(_vendorIdFordocId.length, 8)) + _timestampStr;
    let _altDocId = _altDocIdPrefix + _uid;
    let _projectName = projectName;
    let _quoteStartDate = _rightNow.toISOString().slice(0, 10);

    let _storeId = storeId;

    let _productsStrNodes: string = '';
    let _lineCounter: number = 0;
    productList
      .filter((product: any) => {
        return product.quantity > 0;
      })
      .map((product: any) => {
        _lineCounter++;
        let _ecoTax: number = 0;
        if (product.price.current.additionalData) {
          if (product.price.current.additionalData.deee) {
            _ecoTax = Math.round(parseFloat(product.price.current.additionalData.deee) * 100) / 100;
          }
        }
        // let _shortDescription = product.shortDescription.length > 40 ? product.shortDescription.substr(0,37)+"..." : product.shortDescription;
        //let _commercialDescription = product.commercialDescription.length > 500 ? product.commercialDescription.substr(0, 497) + "..." : product.commercialDescription;
        _productsStrNodes +=
          `
                        <QuoteLine>
                            <oa:LineNumber>` +
          _lineCounter +
          `</oa:LineNumber>
                            <ProductItem>
                                <oa:UPCID>` +
          product.reference +
          `</oa:UPCID> 
          <oa:Description>` +
          this.escapeXml(product.name) +
          `</oa:Description>
          
                            </ProductItem>
                            <oa:Quantity>` +
          product.quantity.toFixed(2) +
          `</oa:Quantity>
                            <oa:UnitPrice>
                                <oa:Amount currencyID="EUR">` +
          product.price.current.value.toFixed(2) +
          `</oa:Amount>
                            </oa:UnitPrice>
                        </QuoteLine>
                        `;
      });
    let _r: string =
      `<?xml version="1.0" encoding="UTF-8"?>
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ns="http://www.kingfisher.com/oagis/9" xmlns:ns1="http://www.openapplications.org/oagis/9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.kingfisher.com/oagis/9 file:///H:/Projects/19189%20SAP%20Template/Misc/Asif/SOA/KITS-SOA_ServiceDefinitions-19189_SAPTemplate/KITS-SOA_ServiceDefinitions-19189_SAPTemplate/com_kingfisher_oagis/9_5_1/Developer/BODs/ProcessQuote.xsd">
        <soapenv:Header/>
        <soapenv:Body>
            <ns:ProcessQuote xmlns="http://www.kingfisher.com/oagis/9" xmlns:oa="http://www.openapplications.org/oagis/9" releaseID="1.0" languageCode="en">
                <oa:ApplicationArea>
                    <oa:Sender>
                        <oa:ComponentID>` +
      _senderComponentId +
      `</oa:ComponentID>
                    </oa:Sender>
                    <oa:CreationDateTime>` +
      _creationDateStr +
      `</oa:CreationDateTime>
                    <oa:BODID>` +
      _uid +
      `</oa:BODID>
                </oa:ApplicationArea>
                <ns:DataArea>
                    <oa:Process>
                        <oa:ActionCriteria>
                            <oa:ActionExpression actionCode="ProcessQuote">ProcessQuote/DataArea/Quote</oa:ActionExpression>
                        </oa:ActionCriteria>
                    </oa:Process>
                    <ns:Quote>
                        <ns:QuoteHeader>
                            <oa:DocumentID>
                                <oa:ID schemeName="QUOTE">` +
      _docId +
      `</oa:ID>
                            </oa:DocumentID>
                            <oa:AlternateDocumentID>
                                <oa:ID schemeName="ProjectReference">` +
      _altDocId +
      `</oa:ID>
                            </oa:AlternateDocumentID>
                            <oa:DocumentReference>
                                <oa:Description type="PROJECT_NAME">` +
      _projectName +
      `</oa:Description>
                                <oa:EffectiveTimePeriod>
                                    <oa:StartDateTime>` +
      _quoteStartDate +
      `</oa:StartDateTime>
                                </oa:EffectiveTimePeriod>
                            </oa:DocumentReference>
                            <oa:Type>` +
      _quoteTypeLetter +
      `</oa:Type>
                            <ns:CustomerParty>
                                <oa:ID>` +
      _customerId +
      `</oa:ID>
                                <SalesOrganisation>
                                    <oa:ID>CA-FR</oa:ID>
                                    <DistributionChannelCode>10</DistributionChannelCode>
                                </SalesOrganisation>
                                <ns:PreferredStoreID>` +
      _storeId +
      `</ns:PreferredStoreID>
                            </ns:CustomerParty>
                        </ns:QuoteHeader>

                        ` +
      _productsStrNodes +
      `

                    </ns:Quote>
                </ns:DataArea>
            </ns:ProcessQuote>
        </soapenv:Body>
    </soapenv:Envelope>`;

    return _r;
  }

  sendLegacyCommerceOrder(
    productList: any,
    projectUuid: string,
    projectName: string,
    projectContext: string,
    customerId: string,
    customerName: string,
    vendorId: string,
    legacyStoreId: string
  ) {
    return new Promise((resolve, reject) => {
      let _trigramme = '3D';
      switch (projectContext) {
        case CONFIG_CONTEXT.KITCHEN:
          _trigramme += 'C';
          break;

        case CONFIG_CONTEXT.STORAGE:
          _trigramme += 'R';
          break;

        default:
          break;
      }

      let _csvStr: string = this.generateLegacyCommerceCSV(
        productList,
        projectUuid,
        projectName,
        projectContext,
        customerId,
        customerName,
        vendorId,
        legacyStoreId
      );

      let _data = new URLSearchParams();
      _data.set('trigramme', _trigramme);
      _data.set('csv', _csvStr);
      _data.set('codeEtablissement', legacyStoreId);

      let _options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
      };

      let _wsUrl: string = this.current.vendor.store.legacySboURL;

      this.http.post(_wsUrl, _data.toString(), _options).subscribe(
        (response: any) => {
          if (response.codeRetour === '0') {
            if (response.numBulletinVente) {
              resolve(response.numBulletinVente);
            } else if (response.path) {
              resolve(response.path);
            } else {
              resolve('Requête OK mais retour erroné');
            }
          } else if (response.codeRetour) {
            let _errorMsg: string = 'Erreur inconnue';

            switch (response.codeRetour) {
              case 'WS_1':
                _errorMsg = 'Requête incomplete : parametres absents (trigramme, csv, codeEtablissement)';
                break;

              case 'WS_2':
                _errorMsg = 'Requête erronée : Erreur lors du decode du csv';
                break;

              case 'WS_3':
                _errorMsg = "Erreur lors de l'execution de la procedure de creation de bv";
                break;

              case 'WS_5':
                _errorMsg = 'Erreur lors de la generation de la liste de course';
                break;

              case 'WS_6':
                _errorMsg = "Erreur generale dans l'action CreateBvAction";
                break;

              case 'WS_7':
                _errorMsg =
                  "le WS n'a pas recu de reponse du repo server pour traiter la demande de generation de la liste de course";
                break;

              case 'WS_8':
                _errorMsg = "le WS n'arrive pas a trouver le repertoire partage";
                break;

              case 'WS_9':
                _errorMsg = "Erreur lors de l'execution de la procedure de creation de LC";
                break;

              default:
                break;
            }
            reject('ERREUR : Code ' + response.codeRetour + '\n' + _errorMsg);
          } else {
            reject('ERREUR INCONNUE');
          }
        },
        (error: any) => {
          logError(error);
          reject(error);
        }
      );
    });
  }

  async sendDotComPlusOrder(quoteRequestXmlString: string): Promise<number> {
    if (environment.production) {
      try {
        const _wsUrl: string = this.current.vendor.store.dotComPlusURL;
        const xmlResponse = await firstValueFrom(
          this.http.post(_wsUrl, quoteRequestXmlString, {
            headers: new HttpHeaders().set('Content-Type', 'text/xml'),
            responseType: 'text'
          }));
        const _jsonResponse: any = Tools.x2js.xml2js(xmlResponse);
        const _opportunityRef = _jsonResponse.Envelope.Body
          .ProcessQuote.DataArea.Quote
          .QuoteHeader.DocumentReference.DocumentID.ID.__text;
        return Number(_opportunityRef);
      } catch (error) {
        logError(error);
        throw error;
      }
    } else {
      // Génération d'un numéro aléatoire
      return Number('100' + Math.floor(Math.random() * 10000000).toString().padStart(7, '0'));
    }
  }
}
